import { render, staticRenderFns } from "./PrintPromo.vue?vue&type=template&id=37ba33b7&scoped=true&"
import script from "./PrintPromo.vue?vue&type=script&lang=js&"
export * from "./PrintPromo.vue?vue&type=script&lang=js&"
import style0 from "./PrintPromo.vue?vue&type=style&index=0&id=37ba33b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ba33b7",
  null
  
)

export default component.exports